<script>
  import _dropdownitem from '../mixins/_dropdown-item'

  export default {
    name: 'DropdownItem',
    mixins: [_dropdownitem]
  }
</script>



// WEBPACK FOOTER //
// dropdown-item.vue?6d06f14d